import { ACCESS_LEVEL } from "./Constant/AccessLevel";

/**
 *
 * @param {*} endPointFlags is from BE, {}
 * @param {*} endPointArray is needed to be checked
 * @returns boolean
 */
const checkEndPoints = (endPointFlags, endPointArray = []) => {
  try {
    if (!endPointFlags) return false;
    let isShow = false;
    endPointArray.forEach((checkEndPoint) => {
      if (endPointFlags[checkEndPoint]) isShow = true;
    });
    return isShow;
  } catch (error) {
    return false;
  }
};

/**
 * endPointFlags : []
 * componentName : str
 * @param endPointFlags
 * @param componentName
 * @param endPointFlags
 * @param componentName
 */
export const showComponent = (endPointFlags, componentName) => {
  return checkEndPoints(endPointFlags, [componentName]);
};
/**
 *  delete
 * @param {*} param0
 * @returns
 */
export const ShowComponent = ({ endPointFlags, componentName }) => {
  return checkEndPoints(endPointFlags, [componentName]);
};

export const showDetailedView = ({ detailed, componentName }) => {
  let show;

  if (detailed.isDetailedOpen === true && detailed.componentName === componentName) {
    show = true;
  } else {
    show = false;
  }

  return show;
};

const getAccessLevel = (role) => {
  try {
    return ACCESS_LEVEL[role.toUpperCase()] || 0;
  } catch (error) {
    return 0;
  }
};

export const hasAccess = (user, requireRole) => {
  try {
    return getAccessLevel(user.role) >= getAccessLevel(requireRole);
  } catch (error) {
    return false;
  }
};
